/** Поиск по подписи в antd Select — без учёта регистра. */
export const defaultFilterOption = (inputValue: string, option: any) => {
  if (!option.label) return false;

  return option.label
    .toString()
    .toLowerCase()
    .includes(inputValue.toLowerCase());
};
